// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'

import BootstrapVue from 'bootstrap-vue'
import VueCookie from 'vue-cookie'
import ElementUI from 'element-ui'

import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/en'
// Vue.http.options.emulateJSON = true

import App from './App'
import router from './router'
import store from './state/store.js'
import { PublicClientApplication } from '@azure/msal-browser'
import axios from './plugins/axios'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
Vue.use(BootstrapVue)
Vue.use(VueCookie)
Vue.use(ElementUI, {locale})

Vue.config.productionTip = false

Vue.component('header-component', require('@/components/topLevel/header.vue').default)
Vue.component('authorization-list-popup', require('@/components/topLevel/authorizationPopup.vue').default)
Vue.component('browser-check', require('@/components/topLevel/browserCheck.vue').default)

Vue.component('currency-input', require('@/components/utility/currencyInput.vue').default)
Vue.component('division-dropdown', require('@/components/utility/divisionDropDown.vue').default)
Vue.component('all-division-dropdown', require('@/components/utility/allDivisionDropDown.vue').default)
Vue.component('status-icon', require('@/components/utility/statusIcon.vue').default)
Vue.component('financial-asset', require('@/components/utility/financialAsset.vue').default)
Vue.component('asset-classification', require('@/components/utility/assetClassification.vue').default)
Vue.component('status-dropdown', require('@/components/utility/statusDropDown.vue').default)
Vue.component('all-status-dropdown', require('@/components/utility/allStatusDropDown.vue').default)
Vue.component('user-dropdown', require('@/components/utility/userDropDown.vue').default)
Vue.component('reason-dropdown', require('@/components/utility/reasonDropDown.vue').default)
Vue.component('department-dropdown', require('@/components/utility/departmentDropDown.vue').default)
Vue.component('tool-tip-popup', require('@/components/utility/toolTip.vue').default)
Vue.component('tool-tip-link-popup', require('@/components/utility/toolTipLink.vue').default)
Vue.component('role-dropdown', require('@/components/utility/PEARoleDropDown.vue').default)
Vue.component('rule-admin-approval-dropdown', require('@/components/utility/RuleAdminApprovalDropDown.vue').default)
Vue.component('rule-division-dropdown', require('@/components/utility/ruleDivisionDropDown.vue').default)
Vue.component('rule-asset-classification', require('@/components/utility/ruleAssetClassification.vue').default)
Vue.component('user-authorization-role-dropdown', require('@/components/utility/userAuthorizationRoleDropDown.vue').default)
// Vue.component('pea-id-dropdown', require('@/components/utility/PEAIdDropDown.vue').default)
Vue.component('pea-table', require('@/components/utility/peaTable.vue').default)

Vue.component('welcome-table', require('@/components/welcome/welcomeTable.vue').default)
Vue.component('welcome-left-link', require('@/components/welcome/welcomeLeftLink.vue').default)

Vue.component('pea-summary', require('@/components/peaMain/peaSummary.vue').default)
Vue.component('pea-status-history', require('@/components/peaMain/peaStatusHistory.vue').default)
Vue.component('pea-financial-assets', require('@/components/peaMain/peaFinancialAssets.vue').default)
Vue.component('pea-check', require('@/components/peaMain/peaCheck.vue').default)
Vue.component('pea-comment', require('@/components/peaMain/peaComment.vue').default)
Vue.component('pea-financial-summary', require('@/components/peaMain/peaFinancialSummary.vue').default)
Vue.component('pea-authorization', require('@/components/peaMain/peaAuthorization.vue').default)
Vue.component('pea-authorization-preview', require('@/components/peaMain/peaAuthorizationPreview.vue').default)
Vue.component('pea-documents', require('@/components/peaMain/peaDocuments.vue').default)
Vue.component('pea-cri', require('@/components/peaMain/peaCRI.vue').default)
Vue.component('pea-statusworkflow', require('@/components/peaMain/peaStatusWorkflow.vue').default)

Vue.component('admin-nav', require('@/components/adminArea/adminNav.vue').default)
Vue.component('change-pea-owner', require('@/components/adminArea/changePEAOwner.vue').default)
Vue.component('pea-approval-roles-rules', require('@/components/adminArea/PEAApprovalRolesAndRules.vue').default)
Vue.component('admin-division-access', require('@/components/adminArea/adminDivisionAccess.vue').default)
Vue.component('admin-view-rolesandusers', require('@/components/adminArea/PEAApprovalRolesAndUsers.vue').default)
Vue.component('admin-change-rolesandusers', require('@/components/adminArea/changeApprovalUserRole.vue').default)
Vue.component('admin-change-approval-rule', require('@/components/adminArea/changeApprovalRule.vue').default)
Vue.component('admin-create-approval-rule', require('@/components/adminArea/createApprovalRule.vue').default)
Vue.component('admin-create-approval-userrole', require('@/components/adminArea/createApprovalUserRole.vue').default)
Vue.component('admin-select-approval-userrole', require('@/components/adminArea/selectApprovalUserRole.vue').default)
Vue.component('admin-view-pea-approvers-by-pea', require('@/components/adminArea/adminViewPeaApproversByPEA.vue').default)
Vue.component('admin-view-notification-listeners', require('@/components/adminArea/PEANotificationListeners.vue').default)
Vue.component('admin-change-notification-listener', require('@/components/adminArea/changeNotificationListener.vue').default)
Vue.component('admin-view-notifications-by-user', require('@/components/adminArea/adminViewPEANotificationsByUser.vue').default)

Vue.component('reports', require('@/components/reports/reports.vue').default)
Vue.component('report-groups', require('@/components/reports/reportGroups.vue').default)
Vue.component('report-table', require('@/components/reports/reportTable.vue').default)
Vue.component('export-report', require('@/components/reports/exportReport.vue').default)

Vue.prototype.$msalInstance = new PublicClientApplication(store.state.msalConfig)
Vue.prototype.$axios = axios

/* eslint-disable no-new */
export default new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App },
  store: store
}).$mount('#app')
